import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline } from './sectionHelpers';

const FaqTwoColumn: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const items = (c.items || []) as Array<{ question: string; answer: string }>;
  const mid = Math.ceil(items.length / 2);
  const col1 = items.slice(0, mid);
  const col2 = items.slice(mid);

  const renderCol = (colItems: typeof items) => (
    <div>
      {colItems.map((item, i) => (
        <div key={i} style={{ marginBottom: 24 }}>
          <h4 style={{ marginBottom: 8 }}>{item.question}</h4>
          <p style={{ color: '#64748b', lineHeight: 1.6 }}>{item.answer}</p>
        </div>
      ))}
    </div>
  );

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 48 }}
        >
          {sfHeadline(c, 'FAQ')}
        </InlineEditText>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48 }}>
          {renderCol(col1)}
          {renderCol(col2)}
        </div>
        {sfCtaText(c) && (
          <div style={{ textAlign: 'center', marginTop: 48 }}>
            <a href={sfCtaUrl(c)} style={{ color: 'var(--brand-primary, #2563eb)', fontWeight: 600, textDecoration: 'none' }}>{sfCtaText(c)}</a>
          </div>
        )}
      </div>
    </section>
  );
};
export default FaqTwoColumn;
